import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/KpiCard";
import { api, errMsg } from "@/lib/api";

const pct = (v) => `${String(v).replace(".", ",")} %`;

export const TauxTalPanel = () => {
  const [data, setData] = useState(null);
  const [annee, setAnnee] = useState("");
  const [base, setBase] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/tal/taux").then((r) => { setData(r.data); setAnnee(String(r.data.annee)); }).catch((e) => toast.error(errMsg(e))); }, []);
  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-emerald-700" />;
  const enregistrer = async () => {
    setBusy(true);
    try { const r = await api.put("/tal/taux", { annee: Number(annee), base: Number(String(base).replace(",", ".")) }); setData(r.data); setBase(""); toast.success("Taux enregistré"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Panel title="Taux du TAL (hausses de loyer)" testId="taux-tal-panel">
      {data.courant.provisoire && <p className="mb-3 rounded-md bg-amber-50 px-3 py-2 text-xs text-amber-800" data-testid="taux-tal-manquant">Le taux de base {data.annee} n'est pas saisi : le calcul utilise celui de {data.courant.annee} ({pct(data.courant.base)}) et l'indique comme provisoire.</p>}
      <ul className="text-xs text-slate-700 space-y-0.5" data-testid="taux-tal-liste">
        {data.taux.map((t) => <li key={t.annee}>{t.annee} : base {pct(t.base)} · travaux majeurs {pct(t.immo)} <span className="text-slate-400">({t.source})</span></li>)}
      </ul>
      <div className="mt-3 flex flex-wrap items-end gap-2">
        <Input value={annee} onChange={(e) => setAnnee(e.target.value)} inputMode="numeric" className="h-8 w-24 text-xs" data-testid="taux-tal-annee" />
        <Input value={base} onChange={(e) => setBase(e.target.value)} placeholder="Taux de base, ex. 3,1" inputMode="decimal" className="h-8 w-44 text-xs" data-testid="taux-tal-base" />
        <Button size="sm" className="h-8 bg-emerald-700 hover:bg-emerald-800" disabled={!annee || !base || busy} onClick={enregistrer} data-testid="taux-tal-enregistrer">Enregistrer</Button>
      </div>
      <p className="mt-2 text-[11px] text-slate-500">Publié chaque janvier sur tal.gouv.qc.ca (« Pourcentages applicables aux critères de fixation de loyer »). Un rappel vous est envoyé fin janvier s'il manque.</p>
    </Panel>
  );
};
